import FlushAccordion from "src/SharedComponents/FlushAccordion/FlushAccordion";
import AuraWeb from "src/images/AuraWeb.png";
import AuraAppLicensesAssigned from "./AuraAppLicensesAssigned/AuraAppLicensesAssigned";
import AuraAppLicensesUnassigned from "./AuraAppLicensesUnassigned/AuraAppLicensesUnassigned";
import { IAuraSoftwareSuiteLicensesInfo, IPartner, IUserLicencesInfo } from "src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo";
import { useCallback, useEffect, useState } from "react";
import SelectedItemsBanner from "src/SharedComponents/SelectedItemsBanner/SelectedItemsBanner";
import AssignLicenseToPartner from "../AssignLicenseToPartner/AssignLicenseToPartner";
import { LicenseType } from "src/Utils/Hooks/LicenseService/useDistributorLicenseService";
import { useDistributorLicenseServiceWrapper } from "src/Utils/Hooks/LicenseService/useDistributorLicenseServiceWrapper";

export interface IAuraAppLicenses{
    auraAppLicenses: IUserLicencesInfo[];
    auraTotalAppLicensesCount: number;
    partner: IPartner[] | undefined;
    updateLicenses: () => void;
    otherLicenses: IAuraSoftwareSuiteLicensesInfo[];
}

const AuraAppLicenses: React.FC<IAuraAppLicenses> = ({auraAppLicenses,auraTotalAppLicensesCount, partner, updateLicenses, otherLicenses}) => {
    const [showAssignPartner, setShowAssignPartner] = useState<boolean>(false);
    const [selectedUserLicenses, setSelectedUserLicenses] = useState<IUserLicencesInfo[]>([]);
    const { reqestResponse, assignLicensePartner } = useDistributorLicenseServiceWrapper();
    
    const clearSelectedUserLicenses = useCallback(() => {
        setSelectedUserLicenses([]);
    }, [])

    const updateUserLicenseCheckbox = (userLicense: IUserLicencesInfo, isSelected: boolean) => {
        setSelectedUserLicenses((prevSelectedUserLicenses) => {
            let updatedLicenses;
            if (isSelected) {
              // Add the selected license to the top of the list
              updatedLicenses = [userLicense, ...prevSelectedUserLicenses];
            } else {
              // Remove the license from the list
              updatedLicenses = prevSelectedUserLicenses.filter(
                (uL: IUserLicencesInfo) => uL.entitlementId !== userLicense.entitlementId
              );
            }
            return updatedLicenses;
        });
    }

    const getLicensesByPartner = (assignedToPartner: boolean) => {
        return auraAppLicenses && auraAppLicenses?.filter((license: IUserLicencesInfo) => license?.isAssignedToPartner === assignedToPartner);
    }

    useEffect(() => {
        if(reqestResponse){
            updateLicenses();
            clearSelectedUserLicenses();
        }
    }, [reqestResponse, updateLicenses, clearSelectedUserLicenses]);

    return(
        <>
            {
                showAssignPartner && 
                <AssignLicenseToPartner
                    onClose={() => {setShowAssignPartner(false)}}
                    onSubmit={(distributorId: string, distributorName: string) => {
                        assignLicensePartner(LicenseType.AuraAppLicenses,distributorId, selectedUserLicenses.map(uL => uL.entitlementId), distributorName);
                        setShowAssignPartner(false);
                    }}
                    partners={partner}
                    selectedUserLicenses={selectedUserLicenses}
                    licenseType="App"
                />
            }
            <FlushAccordion title={`${'Aura App Licenses'} (${auraAppLicenses?.length} / ${auraTotalAppLicensesCount})`} id="AuraAppLicenses" titleImage={AuraWeb} titleImageWidth="72px" marginRightImage="10px">
                <div className="pt-4">
                    {
                        getLicensesByPartner(true).length > 0 ? <AuraAppLicensesAssigned auraAppLicensesAssigned={getLicensesByPartner(true)} updateLicenses={updateLicenses} otherLicenses={otherLicenses}/> : <></>
                    }
                    {
                        getLicensesByPartner(false).length > 0 ? 
                        <AuraAppLicensesUnassigned 
                            auraAppLicensesUnassigned={getLicensesByPartner(false)} 
                            partners={partner} 
                            updateLicenses={updateLicenses}
                            updateUserLicenseCheckbox={updateUserLicenseCheckbox} 
                            isChecked={(license: IUserLicencesInfo) => selectedUserLicenses.some(selected => selected.entitlementId === license.entitlementId)}
                            clearSelectedUserLicenses={clearSelectedUserLicenses}
                        /> 
                        : <></>
                    }
                </div>
            </FlushAccordion>
            {
                selectedUserLicenses.length > 0 &&
                <SelectedItemsBanner
                    selectedItemType="licenses"
                    selectedItemsCount={selectedUserLicenses.length}
                    clearSelectedItems={clearSelectedUserLicenses}
                    setShowAssignPartner={setShowAssignPartner}
                />
            }
        </>
    );
}

export default AuraAppLicenses;